export default __webpack_public_path__ + "static/media/pictogramBeaconMail48.07070a2d.svg";